export const CSAP_ENROLLMENT_OPT_IN = 'opt-in';
export const CSAP_ENROLLMENT_OPT_OUT = 'opt-out';
export const CSAP_ELIGIBILITY_TIME_IN_DAYS = 180;
